"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _AnalyticsConfiguration_1 = require("./_AnalyticsConfiguration");
exports.PutBucketAnalyticsConfigurationInput = {
    type: "structure",
    required: ["Bucket", "Id", "AnalyticsConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        Id: {
            shape: {
                type: "string"
            },
            location: "querystring",
            locationName: "id"
        },
        AnalyticsConfiguration: {
            shape: _AnalyticsConfiguration_1._AnalyticsConfiguration,
            locationName: "AnalyticsConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "AnalyticsConfiguration"
};
//# sourceMappingURL=PutBucketAnalyticsConfigurationInput.js.map